import { FilterButton } from '@/design-system/components/buttons/filterButton/FilterButton';
import { H6, TextCaption } from '@/design-system/components/typography';
import { formatAmountByDecimals } from '@/utils/numberFormatting';
import { SxProp, View } from 'dripsy';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MyEarningsProps } from './MyEarnings';
import { MyEarningsBarChart } from './MyEarningsBarChart';
import { AnalyticRange } from './useMyEarnings.hook';

export interface MyEarningsNativeProps extends MyEarningsProps {}

export const MyEarningsNative: React.FC<MyEarningsNativeProps> = ({ overview, currency, barChartData, analyticRange, changeDateRange }) => {
  const { t } = useTranslation('earn');
  const [containerWidth, setContainerWidth] = useState(0);

  return (
    <View sx={styles.container}>
      <View
        sx={styles.innerContainer}
        onLayout={(event) => {
          setContainerWidth(event.nativeEvent.layout.width);
        }}>
        <View sx={{ flexDirection: 'row', gap: '$2' }}>
          <FilterButton
            label={t('earn-invest::glossary.seven-days')}
            isSelected={analyticRange === AnalyticRange.$7Day}
            onPress={() => changeDateRange(AnalyticRange.$7Day)}
            value={AnalyticRange.$7Day.toString()}
            sx={{ flex: 1 }}
          />
          <FilterButton
            label={t('earn-invest::glossary.thirty-days')}
            isSelected={analyticRange === AnalyticRange.$30Day}
            onPress={() => changeDateRange(AnalyticRange.$30Day)}
            value={AnalyticRange.$30Day.toString()}
            sx={{ flex: 1 }}
          />
          <FilterButton
            label={t('earn-invest::glossary.ninety-days')}
            isSelected={analyticRange === AnalyticRange.$90Day}
            onPress={() => changeDateRange(AnalyticRange.$90Day)}
            value={AnalyticRange.$90Day.toString()}
            sx={{ flex: 1 }}
          />
        </View>
        <View>
          <TextCaption secondary label>
            {t('earn-invest::glossary.mobile-yesterdays-earnings')}
          </TextCaption>
          <H6 bold success>
            {formatAmountByDecimals({ value: overview?.yesterday || 0, decimals: 2, suffix: currency })}
          </H6>
        </View>
        <MyEarningsBarChart data={barChartData} />
      </View>
    </View>
  );
};

enum StyleName {
  container = 'container',
  innerContainer = 'innerContainer'
}

const styles: Record<StyleName, SxProp> = {
  container: { flex: 1, paddingX: '$4', padding: '$5' },
  innerContainer: { flex: 1, gap: '$5', justifyContent: 'flex-start' }
};
